import React, { lazy, Suspense, memo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/shared-components/Loading";
import ErrorBoundary from "components/shared-components/ErrorBoundary";
import Views from "views";
import { setAccess } from "store/slices/AccessSlice";
import jwtDecode from "jwt-decode";
import userService from "services/user";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("auth_token")) {
      getUserAccess();
    }
  }, []);

  const getUserAccess = async () => {
    try {
      setLoading(true);
      const tokenData = jwtDecode(localStorage.getItem("auth_token"));
      const response = await userService.getAllUserAccess(tokenData.userId);
      if (response) {
        const normalized = {};

        Object.keys(response).forEach((key) => {
          // ignore metadata keys
          if (key.startsWith("_") || key === "orgId" || key === "accessName") {
            return;
          }

          normalized[key] = {
            active: Boolean(response[key]?.active),
          };
        });
        dispatch(setAccess(normalized));
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading cover="content" />;

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Views />
        </Layout>
      </Suspense>
    </ErrorBoundary>
  );
};

export default memo(Layouts);
